export const environment = {
  production: true,
  apiUrl: "https://manager-residenz-dev.chapps.com/",
  name: 'Dev',
  accountSiteUrl: 'https://account-dev.chapps.com/',
  zendeskUrl: 'https://chapps.freshdesk.com/',
  residenzSiteUrl: 'https://residenz-dev.chapps.com',
  buildingManagerUrl: 'https://building-dev.chapps.com',

  features: {
    spf: true,
  }
};
